module.exports = __webpack_public_path__ + "img/shop-ad-01.1b65b43f.png";